import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux'; 

const MSMELiteracyKit = () => {
  const authState = useSelector(state => state.authReducer);
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();

  const kititems = [
      {
        id: 1,
        title: "Startup Kit",
        description: "Access over 220 ready-to-use business templates to streamline HR, operations, finance, marketing, and compliance.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/startup-kit.jpg"
      },
      {
        id: 2,
        title: "MSME Owner Productivity Hack eBook",
        description: "Tools and techniques to maximize personal and team efficiency for MSME owners.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/productivity-hack.jpg"
      },
      {
        id: 3,
        title: "MSME Digital Readiness & BPM Maturity Evaluation Kit",
        description: "A structured guide to evaluate digital transformation and business process management maturity.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/digital-readiness.jpg"
      },
      {
        id: 4,
        title: "RACI Matrix Guide",
        description: "Define and communicate roles and responsibilities within your team or project with this responsibility assignment tool.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/raci-matrix.jpg"
      },
      {
        id: 5,
        title: "AIfy MSME: A Digital Book",
        description: "Practical insights for adopting AI in MSME business processes to enhance efficiency.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/aify-msme.jpg"
      },
      {
        id: 6,
        title: "Purple Power: Six Sigma for MSMEs",
        description: "A lightweight, MSME-specific guide to Six Sigma for achieving process excellence.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/purple-power.jpg"
      },
      {
        id: 7,
        title: "FLOURISH: Financial Literacy for MSMEs",
        description: "Essential financial literacy eBook to empower MSMEs with financial management skills.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/flourish.jpg"
      },
      {
        id: 8,
        title: "Cyberwisdom for MSMEs",
        description: "A comprehensive eBook on cybersecurity awareness tailored for MSME needs.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/cyberwisdom.jpg"
      },
      {
        id: 9,
        title: "JAGRUK: Legal & Civic Literacy",
        description: "Justice Awareness Guidance Rights Unity Knowledge eBook for basic legal and civic literacy.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/jagruk.jpg"
      },
      {
        id: 10,
        title: "Think5Whys: Problem-Solving Mastery",
        description: "Learn the 5 Whys analysis technique for systematic root cause problem-solving.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/think5whys.jpg"
      },
      {
        id: 11,
        title: "MSME Loans Demystified",
        description: "A complete guide to financial empowerment, risk-free borrowing, and smart growth for MSMEs.",
        img: "/api/downloads/thinkdscut/sakshambharat/courses/loans-demystified.jpg"
      }
  ];

  return (
    <section id="whykit" className="py-4 px-6 md:px-20 bg-gradient-to-r from-teal-700 to-indigo-600">
        <h2 className="text-xl font-bold text-center mb-4 text-white">SAKSHAM MSME Literacy Kit</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
          {kititems.map((kititem) => (
            <div key={kititem.id} className="bg-white shadow-lg hover:shadow-2xl transition rounded-xl overflow-hidden transform hover:-translate-y-2">
              <div className="p-6">
                <h3 className="text-lg font-semibold text-gray-900">{kititem.title}</h3>
                <p className="text-gray-700 mt-3">{kititem.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
  );
};

export default MSMELiteracyKit;
